import { template as template_7488f4197b8c464daafe8fe5edec791d } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { eq } from '@cardstack/boxel-ui/helpers';
interface Signature {
    Args: {
        type: 'index' | 'stack' | 'card';
        message: any;
        operatorModeState?: string;
    };
}
const CardError: TemplateOnlyComponent<Signature> = template_7488f4197b8c464daafe8fe5edec791d(`
  <div data-card-error class='container'>
    {{#if (eq @type 'index')}}
      <b>Cannot load index card.</b>
    {{else if (eq @type 'stack')}}
      <b>Cannot load stack.</b>
    {{else}}
      <b>Cannot load card.</b>
    {{/if}}
    <pre class='error'>{{@message}}</pre>

    {{#if @operatorModeState}}
      <pre class='error'>Operator mode state: {{@operatorModeState}}</pre>
    {{/if}}
  </div>
  <style scoped>
    .container {
      margin: 5em;
    }

    .error {
      overflow-x: auto;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  </style>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default CardError;
